var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.31641 22.9807C9.41336 22.8832 9.4903 22.7673 9.54281 22.6396C9.59532 22.5118 9.62235 22.3748 9.62235 22.2364C9.62235 22.098 9.59532 21.961 9.54281 21.8333C9.4903 21.7055 9.41336 21.5896 9.31641 21.4921L4.55872 16.6701L28.9057 16.6701C29.18 16.6701 29.4431 16.5596 29.6371 16.363C29.831 16.1664 29.94 15.8998 29.94 15.6218C29.94 15.3438 29.831 15.0771 29.6371 14.8805C29.4431 14.684 29.18 14.5735 28.9057 14.5735L4.5794 14.5735L9.31641 9.78289C9.50905 9.58648 9.61718 9.32079 9.61718 9.04385C9.61718 8.76691 9.50905 8.50123 9.31641 8.30482C9.12263 8.10958 8.86049 7.99999 8.58725 7.99999C8.314 7.99999 8.05186 8.10958 7.85808 8.30482L1.28004 14.9719C1.1915 15.058 1.12106 15.1613 1.07293 15.2757C1.02481 15.3901 1 15.5132 1 15.6375C1 15.7619 1.02481 15.8849 1.07293 15.9993C1.12106 16.1137 1.1915 16.2171 1.28004 16.3032L7.84773 22.9807C7.94388 23.0789 8.05828 23.1569 8.18431 23.2102C8.31035 23.2634 8.44554 23.2908 8.58208 23.2908C8.71861 23.2908 8.8538 23.2634 8.97983 23.2102C9.10587 23.1569 9.22026 23.0789 9.31641 22.9807Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftIcon);
export default __webpack_public_path__ + "static/media/arrow-left-icon.dc209014a9c3d5f8c6bc127f2dba0007.svg";
export { ForwardRef as ReactComponent };